import { COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS } from '@core/components/component-factory/component-factory-config-input.registry';
import type { ConfigComponentContract } from '@shared/utils/content-builder/config-component-contract';
import { computedResolvedConfig } from '@shared/utils/content-builder/block-config-computed-resolver';
import type { MainLayoutConfig } from '@front-platform/content-builder';
import { mainLayoutResolveConfig } from '@front-platform/content-builder';
import { Component, effect, input, inject, computed } from '@angular/core';
import { KioskService } from '@core/services/kiosk/kiosk.service';
export interface MainLayoutRuntimeConfig {
  'footer'?: unknown[];
  'global_features'?: unknown[];
}

export type MainLayoutConfigInput = Partial<
  Omit<MainLayoutConfig, keyof MainLayoutRuntimeConfig> & MainLayoutRuntimeConfig
>;
export type MainLayoutResolvedConfig = Omit<MainLayoutConfig, keyof MainLayoutRuntimeConfig> &
  Partial<MainLayoutRuntimeConfig>;
export interface MainLayoutContract extends ConfigComponentContract<
  MainLayoutConfigInput,
  MainLayoutResolvedConfig
> {}

@Component({
  selector: 'app-main-layout',
  templateUrl: './main-layout.component.html',
  standalone: false,
})
export class MainLayoutComponent implements MainLayoutContract {
  readonly config = input<MainLayoutConfigInput>({});
  readonly resolvedConfig = computedResolvedConfig<MainLayoutConfig, MainLayoutRuntimeConfig>(
    mainLayoutResolveConfig,
    () => ({ config: this.config() }),
  );
  readonly footer = computed(() => this.resolvedConfig()['footer'] as unknown as unknown[]);
  readonly globalFeatures = computed(
    () => this.resolvedConfig()['global_features'] as unknown as unknown[],
  );
  readonly displayDefaultDoodFooter = computed(
    () => this.resolvedConfig()['display_default_dood_footer'] as unknown as boolean,
  );
  readonly isKioskLayout = computed(
    () => this.resolvedConfig()['is_kiosk_layout'] as unknown as boolean,
  );

  private readonly kioskService = inject(KioskService);

  constructor() {
    // effect() runs when isKioskLayout is set/updated by the parent (constructor runs before inputs are set)
    effect(() => {
      this.kioskService.saveKioskLayoutToStore(this.isKioskLayout());
    });
  }
}
COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS.set(MainLayoutComponent, { 'keyAliases': {} });
